import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
//
import { brands } from '../../data/brandsData';
//
import Layout from '../../components/Layout';
import BannerSliderView from './components/BannerSliderView';
import CategoryView from './components/CategoryView';
import RequestQuoteSection from './components/RequestQuoteSection';
import SliderView from '../../components/SliderView';
import FeaturedProductsView from './components/FeaturedProductsView';
import NewArrivalsView from './components/NewArrivalsView';
import EmailSubscribeView from './components/EmailSubscribeView';
import NewsletterView from './components/NewsletterView';
import BestSellersView from './components/BestSellersView';
import { getStoreInfo } from '../../api/services/systemService';
import { initUserInfo, setUserInfo } from '../../redux/userInfo';
import ShopByCategoryView from './components/ShopByCategoryView';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 1.5%;
  justify-content: space-between;
`;

const BrandCard = styled.div`
  display: flex;
  width: 200px;
  height: 100px;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 5px;
  padding: 0 30px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  img {
    max-width: 120px;
    max-height: 80px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`;

const BrandCardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  ${BrandCard}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

const BrandSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 20px 30px 0 30px;

  @media (max-width: 768px) {
    padding: 15px 20px 0 20px;
  }

  @media (max-width: 480px) {
    padding: 10px 15px 0 15px;
  }
`;

const BrandSectionTitle = styled.h1`
  font-size: 30px;
  color: ${(props) => props.theme.colors.primaryText};
  margin: 0;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const ViewAllButton = styled.button`
  background: none;
  border: none;
  color: #2b83bf;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export default function HomePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo);
  const scrollAttempted = useRef(false);

  const token = localStorage.getItem('token');

  if (token === 'null' && userInfo.userId != 0) {
    // 토큰이 없는데 유저 정보가 있다 , 세션 초기화
    dispatch(initUserInfo());
  }

  useEffect(() => {
    getDbStoreInfo();
  }, []);

  useEffect(() => {
    // Check if we should scroll to category section after returning from category page
    const shouldScroll = sessionStorage.getItem('scrollToCategoryView');

    if (shouldScroll === 'true' && !scrollAttempted.current) {
      scrollAttempted.current = true;

      // Use multiple attempts to ensure scroll happens after all content loads
      const attemptScroll = (attempts = 0) => {
        if (attempts > 5) {
          // Clear flag after max attempts
          sessionStorage.removeItem('scrollToCategoryView');
          return;
        }

        const categorySection = document.getElementById('category-section');
        if (categorySection) {
          // Add small delay between attempts to catch layout changes
          setTimeout(
            () => {
              categorySection.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });

              // Clear the flag after successful scroll
              if (attempts === 3) {
                sessionStorage.removeItem('scrollToCategoryView');
              }
            },
            200 * (attempts + 1),
          );
        }
      };

      // Start scroll attempts
      attemptScroll(0);
      attemptScroll(1);
      attemptScroll(2);
      attemptScroll(3);
    }
  }, []);

  const getDbStoreInfo = async () => {
    const result = await getStoreInfo();
    dispatch(
      setUserInfo({
        idStore: result.storeInfo.idStore,
        zipcode: result.storeInfo.zipcode,
      }),
    );
  };

  return (
    <Layout>
      {/* 이미지 배너 슬라이더 */}
      <BannerSliderView />
      {/* Request Quote 섹션 */}
      <RequestQuoteSection />
      <Container>
        {/* 카테고리 카드 */}
        <CategoryView />
        {/* 슬라이더
        {hotProductList.length > 0 ? (
          <SliderView title={'Hot Items'}>
            {hotProductList.map((item, index) => (
              <div key={`product_hot_${index}`}>
                <ProductCard data={item} key={`product_${index}`} />
              </div>
            ))}
          </SliderView>
        ) : null}
        {newProductList.length > 0 ? (
          <SliderView title={'New Arrivals'}>
            {newProductList.map((item, index) => (
              <div key={`product_new_${index}`}>
                <ProductCard data={item} key={`product_${index}`} />
              </div>
            ))}
          </SliderView>
        ) : null}
        {restaurantProductList.length > 0 ? (
          <SliderView title={'Restaurant Supplies'}>
            {restaurantProductList.map((item, index) => (
              <div key={`product_restaurant_${index}`}>
                <ProductCard data={item} key={`product_${index}`} />
              </div>
            ))}
          </SliderView>
        ) : null} */}
      </Container>
      <BestSellersView />
      <EmailSubscribeView />
      <NewArrivalsView />
      <NewsletterView />
      <ShopByCategoryView />
      <FeaturedProductsView />
      <Container>
        {/* 브랜드 카드 슬라이더 */}
        <div style={{ marginTop: '30px', backgroundColor: '#F6F6F6' }}>
          <BrandSectionHeader>
            <BrandSectionTitle>Shop By Brand</BrandSectionTitle>
            <ViewAllButton
              onClick={() => {
                if (userInfo.userId != 0) {
                  navigate('/brands');
                } else {
                  navigate('/login');
                }
              }}
            >
              View All &gt;
            </ViewAllButton>
          </BrandSectionHeader>
          <SliderView style={{ backgroundColor: '#F6F6F6' }}>
            {brands.map((item, index) => (
              <BrandCard
                onClick={() => {
                  if (userInfo.userId != 0) {
                    const brandNameWithoutSpaces = item.name.replace(
                      /\s+/g,
                      '',
                    );
                    navigate(
                      `/search?brand=${encodeURIComponent(brandNameWithoutSpaces)}`,
                    );
                  } else {
                    navigate('/login');
                  }
                }}
                key={`brand_${index}`}
              >
                <img src={item.logo} alt={item.name} />
                <BrandCardOverlay />
              </BrandCard>
            ))}
          </SliderView>
        </div>
      </Container>
    </Layout>
  );
}
